"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
var Types = {
    CustomerPortalService: Symbol.for("CustomerPortalService"),
    CustomerPortalServiceConfig: Symbol.for("CustomerPortalServiceConfig"),
    PluginHelperServiceConfig: Symbol.for("PluginHelperServiceConfig"),
    FalconLookupService: Symbol.for("FalconLookupService"),
    PluginHelperService: Symbol.for("PluginHelperService"),
    BaseRequestService: Symbol.for("BaseRequestService"),
    NotificationService: Symbol.for("NotificationService"),
    FalconConvenienceApiServiceConfig: Symbol.for("FalconConvenienceApiServiceConfig"),
    FalconConvenienceApiService: Symbol.for("FalconConvenienceApiService"),
    CacheManager: Symbol.for("CacheManager"),
    LoggerService: Symbol.for("LoggerService"),
    MonitoringToolService: Symbol.for("MonitoringToolService"),
    RuntimeServiceConfig: Symbol.for("RuntimeServiceConfig"),
    FalconPropositionEngine: Symbol.for("FalconPropositionEngine")
};
exports.Types = Types;
//# sourceMappingURL=Types.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/Types.js
// module id = 161
// module chunks = 0